import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Card } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';

import { columns } from './columns';

const AdminContractsList = () => {
    const { masterContracts } = useSelector((state) => state.admin);
    const history = useHistory();

    const dataToRender = () => {
        if (!masterContracts) {
            return [];
        } else {
            return masterContracts
                .filter((i) => !i.isDeprecated)
                .map((contract) => {
                    return {
                        ...contract,
                        onCellClick: (contractID) =>
                            history.push(
                                `/administration/contracts/${contractID}`
                            ),
                    };
                })
                .sort((contract1, contract2) => {
                    if (contract1.type > contract2.type) {
                        return -1;
                    } else if (contract1.type < contract2.type) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
        }
    };

    return (
        <Fragment>
            <Card className="overflow-hidden">
                <div className="react-dataTable">
                    <DataTable
                        noHeader
                        responsive
                        columns={columns}
                        sortIcon={<ChevronDown />}
                        highlightOnHover
                        pointerOnHover
                        onRowClicked={({ _id }) =>
                            history.push(`/administration/contracts/${_id}`)
                        }
                        className="react-dataTable"
                        data={dataToRender()}
                    />
                </div>
            </Card>
        </Fragment>
    );
};

export default AdminContractsList;
